import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type FormApplicationNotificationsDefaultProps = {
  emailAddress1?: string;
  emailAddress2?: string;
  emailAddress3?: string;
};

function FormApplicationNotificationsDefault({
  emailAddress1,
  emailAddress2,
  emailAddress3,
}: FormApplicationNotificationsDefaultProps) {
  const { t } = useSonTranslation('FormApplicationNotifications');

  return (
    <div className="form-application-notifications__default-container">
      <dl className="form-application-notifications__description-list">
        {emailAddress1 && (
          <>
            <dt className="form-application-notifications__description-list-term font-bold-16-19">
              {t('form.emailAddress1Label')}:
            </dt>
            <dd className="form-application-notifications__description-list-description font-regular-16-19">
              {emailAddress1}
            </dd>
          </>
        )}
        {emailAddress2 && (
          <>
            <dt className="form-application-notifications__description-list-term font-bold-16-19">
              {t('form.emailAddress2Label')}:
            </dt>
            <dd className="form-application-notifications__description-list-description font-regular-16-19">
              {emailAddress2}
            </dd>
          </>
        )}
        {emailAddress3 && (
          <>
            <dt className="form-application-notifications__description-list-term font-bold-16-19">
              {t('form.emailAddress3Label')}:
            </dt>
            <dd className="form-application-notifications__description-list-description font-regular-16-19">
              {emailAddress3}
            </dd>
          </>
        )}
      </dl>
    </div>
  );
}

export const FormApplicationNotificationsDefaultView = asFetchableView(FormApplicationNotificationsDefault);
export type FormApplicationNotificationsDefaultView = ComponentProps<typeof FormApplicationNotificationsDefaultView>;
